import { Printer } from "lucide-react";
import { API } from "@/lib/api";

export const SheetLink = ({ appId }) => (
  <a href={`${API}/admin/applications/${appId}/sheet`} target="_blank" rel="noopener noreferrer" data-testid="application-sheet-link"
    className="inline-flex items-center gap-2 bg-[#e9458f] px-5 py-3 font-mono text-xs uppercase tracking-[0.15em] text-[#1c1418]">
    <Printer className="h-4 w-4" /> Scheda A4 da stampare
  </a>
);
